export default __webpack_public_path__ + "static/media/market-team.0cefc7a4.png";